export default "__VITE_ASSET__sLTHpKsMCAfgHvMqxWqT0w__"